export default __webpack_public_path__ + "static/media/bg-img.80ca61e9.png";